// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  basketTotalContainer: {
    position: 'absolute',
    top: 20,
    right: 20,
    [theme.breakpoints.down(651)]: {
      position: 'relative',
    },
  },
  selectPaymentForm: {
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: 450,
    [theme.breakpoints.down(450)]: {
      width: '90%',
    },
  },
  noteTextContainer: {
    maxWidth: 400,
    padding: '0 10px',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GREY,
  },
  noteText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  secureTextContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
    marginBottom: 20,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GREY,
  },
  marginLeft: {
    marginLeft: 5,
  },
  secureImage: {
    width: 15,
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  errorMessage: {
    color: GlobalStyles.color.COLOR_REJECT,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  updateText: {
    color: GlobalStyles.color.COLOR_GREEN,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
  },
  rejectedColor: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  questionText: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    margin: '20px 0',
    padding: '0 10px',
    letterSpacing: 1.1,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    }
  }
});

export default styles;
